module.exports = __webpack_public_path__ + "media/assets/illustrations/coffee-animation-beed3308c61474384e247399bbd7d21a.gif";